import { Component, Input, OnInit } from '@angular/core';
import { GfTranslateService } from '../../../../../core/services/core.translate.service';
import { UserService } from '../../../../../core/services/core.user.service';
import { UiService } from '../../../../../core/services/core.ui.service';
import { TrackeritemQueueService } from '../../../services/trackeritem.queue.service';
import { TrackeritemService } from '../../../services/trackeritem.service';
import * as _ from 'lodash';

@Component({
  selector: 'trackeritem-queue-toggle',
  template: `<button type="button" id="TIto-do" style="z-index: 0;" 
              [title]="queueButtonTitle(trackeritem)" 
              class="btn" 
              [ngClass]="{ 'btn-primary': inQueue(trackeritem), 'btn-default': !inQueue(trackeritem) }" 
              (click)="toggleQueue(trackeritem)" 
              [disabled]="!canAddRemoveQueue(trackeritem)">
              <span class="glyphicon" 
                [ngClass]="{ 'glyphicon-star': inQueue(trackeritem), 'glyphicon-star-empty': !inQueue(trackeritem) }">
              </span>
            </button>`
})
export class TrackeritemQueueToggleComponent implements OnInit {
  @Input() trackeritem: any;
  @Input() acls: any;
  monitoring: boolean = false;

  constructor(
    private translateService: GfTranslateService,
    private userService: UserService,
    private uiService: UiService,
    private trackeritemQueueService: TrackeritemQueueService,
    private trackeritemService: TrackeritemService
  ) {}

  ngOnInit() {
    this.trackeritemQueueService.updateQueue()
      .then(() => {
        this.queueButtonTitle(this.trackeritem);
      });
  }

  assignTiToUser(trackeritem: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const assignee = _.find(trackeritem.rel.assignees, (assignee) => {
        return this.userService.session.getUserId() === assignee.id;
      });

      if (assignee && assignee.id !== 100 && trackeritem.rel.assignees.length === 1) {
        resolve({ trackeritem });
      } else {
        const _trackeritem = _.cloneDeep(trackeritem);
        _trackeritem.rel.assignees = [this.userService.session.getUser()];

        this.trackeritemService.save(trackeritem, {})
          .then(() => {
            trackeritem = _trackeritem;
            resolve({ trackeritem });
          })
          .catch(() => {
            reject();
          });
      }
    });
  }

  inQueue(item: any): boolean {
    return this.trackeritemQueueService.inQueue(item);
  }

  queueButtonTitle(item: any): string {
    if (this.canAddRemoveQueue(item)) {
      if (this.trackeritemQueueService.inQueue(item)) {
        return this.translateService.translate('This Tracker Item is in your To-Do. Click to remove');
      } else {
        return this.translateService.translate('This Tracker Item is not in your To-Do. Click to add');
      }
    }
    return '';
  }

  addToQueue(item: any) {
    if (!this.userService.session.hasUser()) {
      return;
    }

    this.assignTiToUser(this.trackeritem)
      .then(() => {
        this.trackeritemQueueService.addToQueue(item.id);
      })
      .catch(() => {
        const addedQMsg = this.translateService.translate('Sorry, could not add #{{item}} to your To-Do', { item: item.id });
        const errorMsg = this.translateService.translate('To-Do Update Failed');
        this.uiService.message.showWarning(addedQMsg, errorMsg);
      });
  }

  removeFromQueue(item: any, silent: boolean) {
    if (!this.userService.session.hasUser()) {
      return;
    }

    this.trackeritemQueueService.removeFromQueue(item.id, silent);
  }

  canAddRemoveQueue(item: any): boolean {
    return (this.acls.canAssign || 
            this.trackeritemService.isAssignedTo(item, this.userService.session.getUser()) || 
            this.trackeritemQueueService.inQueue(item));
  }

  toggleQueue(item: any) {
    if (this.canAddRemoveQueue(item)) {
      if (this.trackeritemQueueService.inQueue(item)) {
        this.removeFromQueue(item, false);
      } else {
        this.addToQueue(item);
      }
    }
  }
}

